import BoardOfDirectors from "./pages/home/BoardOfDirectors.jsx"; // Adjust the path if needed
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Home({ children }) {
  

  return (
    <main className="d-flex flex-column align-items-center w-100  flex-grow-1">
      {/* Hero Section with Background Image & Blur Overlay */}
      <section
        className="position-relative w-100 vh-100 d-flex flex-column align-items-center justify-content-center text-white text-center p-4"
        style={{
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          maxHeight: "89vh"
        }}
        id="top"
      >
        {/* Overlay for Blur Effect */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: "rgba(64, 81, 148, 0.5)", // Adjust transparency
            backdropFilter: "blur(3px)", // Blur effect
            WebkitBackdropFilter: "blur(3px)", // Safari support
          }}
        ></div>

        {/* Content (Make sure it is above the overlay) */}
        <div className="position-relative z-1">
          <h1 className="fw-bold" style={{ fontSize: "3rem" }}>
            Welcome to Blueberry Infratech
          </h1>          
          <p className="mt-3 fs-5">Building the future with innovation and precision.</p>
          {/* <button className="mt-4 btn btn-light text-primary fw-bold">Explore More</button> */}
        </div>
      </section>

      {/* About Us Section */}
      <section className="w-100 py-5 bg-light text-center" id="about-us">
        <div className="container px-4">
          <h2 className="fw-bold text-primary">About Us</h2>
          <p className="mt-3 fs-5 text-secondary">
            Blueberry Infratech is a leading engineering and core infrastructure company that has established a strong presence in the industry. Founded on a visionary dream and built on a foundation of integrity and innovation, we leverage cutting-edge technology to drive progress. With an unwavering commitment to excellence, we continue to shape India's infrastructure landscape, setting new benchmarks for growth and sustainability.
          </p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="w-100 py-5 bg-white text-center" id="vision">
        <div className="container px-4">
          <h2 className="fw-bold text-primary">Our Vision</h2>
          <p className="mt-3 fs-5 text-secondary">
            Our vision is to transform the infrastructure industry with innovative solutions while building a leading company that upholds the highest standards of quality, customer service, and sustainable growth.
          </p>
        </div>
      </section>

      {/* Board of Directors Section */}
      <BoardOfDirectors />

      {/* Page Content */}
      <div className="flex-grow-1 w-100">{children}</div>
    </main>
  );
}
